import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './fonts.css';
import './index.css'
import App from './App.tsx'
import { Helmet, HelmetProvider } from "react-helmet-async";
import { DebugBoundary } from './components/DebugBoundary.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

createRoot(document.getElementById('root')!).render(
  <DebugBoundary>
    <ErrorBoundary>
      <StrictMode>
        <HelmetProvider>
          <Helmet>
            <title>Événements à Québec - Activités et Sorties</title>
            <meta name="description" content="Découvre les meilleurs événements et activités à Québec! Trouve quoi faire aujourd'hui, ce week-end ou ce mois-ci : musique, humour, théâtre, famille, etc." />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Événements à Québec - Activités et Sorties" />
            <meta property="og:description" content="Découvre les meilleurs événements et activités à Québec! Trouve quoi faire aujourd'hui, ce week-end ou ce mois-ci : musique, humour, théâtre, famille, etc." />
            <meta property="og:image" content="https://alentours.ca/favicon.png" />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content="Événements à Québec - Activités et Sorties" />
            <meta name="twitter:description" content="Découvre les meilleurs événements et activités à Québec! Trouve quoi faire aujourd'hui, ce week-end ou ce mois-ci : musique, humour, théâtre, famille, etc." />
            <meta name="twitter:image" content="https://alentours.ca/favicon.png" />
          </Helmet>
          <App />
        </HelmetProvider>
      </StrictMode>
    </ErrorBoundary>
  </DebugBoundary>,
)
